export default "__VITE_ASSET__077e73ba__"